export const CATEGORY_ORDER = [
  "All",
  "Data Graphics",
  "Dashboards & Scrollytelling",
  "Reports & Articles",
  "Presentations",
  "Illustrations",
  "Client Projects",
];

export const CATEGORY_DESCRIPTIONS = {
  All: "All projects across data journalism, policy research, illustration and editorial design.",
  "Data Graphics":
    "Static data visualisations & animations created with self-guided research prompts.",
  "Dashboards & Scrollytelling":
    "Interactive web experiences and dynamic storytelling where audience can interact with the data and story through hovers, clicks and scrolling.",
  "Reports & Articles":
    "Written research, published reports and long-form articles.",
  Presentations: "Talks, conference presentations and visual slide decks.",
  Illustrations:
    "Character design, editorial illustration and hand-drawn work.",
  "Dear Sustie":
    "A series of illustrated sustainability guides tackling everyday environmental choices.",
};

// ─────────────────────────────────────────────────────────────────────────────
// PORTFOLIO DATA — generated from Airi_Project.csv
//
// HOW TO ADD MEDIA (images / videos):
//   1. In CodeSandbox: drag your file into the `public/media/` folder
//      (create the folder if it doesn't exist)
//   2. Set `thumbnail` to the gallery card image/video, e.g. "/media/my-project.jpg"
//   3. Set `media` to the full-resolution version shown on the project page
//   4. Set `mediaType` to "image" or "video"
//
// If a project has a `link` value, the project page will show an iframe/button
// to that external URL instead of a local image.
// ─────────────────────────────────────────────────────────────────────────────

export const portfolioItems = [
  {
    display: "media",
    slug: "global-trade-flow-of-coffee",
    title: "Global Trade Flow of Coffee",
    categories: ["Data Graphics"],
    description:
      "Almost all coffee producing countries are located in areas with high climate risk 🔥. Yet, there is not enough investment and effort from the industry to protect these places from future climate events. Most countries import the majority of their coffee from 5 countries or less. With our global coffee chain so dependent on such few countries, what would the future of coffee look like as the planet changes 🌏 ? ",
    projectTypes: ["Data Visualisation"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["RawGraphs 2.0", "Flourish"],
    analyticsTools: ["Excel"],
    date: "2023-03-01",
    link: "https://www.visualcapitalist.com/cp/global-coffee-trade/",
    linkLabel: "Link to Visual Capitalist Page →",
    sourceLabel: "Resource Trade Earth",
    sourceLink: "https://resourcetrade.earth/",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128955/global-trade-flow-of-coffee_ly3cd3.jpg",
    thumbnailRatio: 0.26462027,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128955/global-trade-flow-of-coffee_ly3cd3.jpg",
    mediaType: "image",
    accentColor: "#EB8015",
    span: "wide",
  },
  {
    display: "iframe",
    slug: "more-than-just-an-anime",
    title: "More than just an anime",
    categories: ["Dashboards & Scrollytelling"],
    description:
      "Are political anime like One Piece more likely to be popular in countries with political instability? Explore what I found out through this web scrollytelling piece.",
    projectTypes: [
      "Visual Journalism",
      "Web Scrollytelling",
      "Data Visualisation",
    ],
    designTools: ["Figma", "React.js"],
    graphicTools: ["RawGraphs 2.0"],
    analyticsTools: ["Excel", "Desk-based Research"],
    date: "2025-12-12",
    link: "https://egg-fling-78174909.figma.site/",
    linkLabel: "Link to website",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128953/more-than-just-an-anime_yslzbf.mp4",
    thumbnailRatio: 1.861777151,
    media: null,
    mediaType: "video",
    accentColor: "#A65E5D",
    span: "tall",
  },

      {
    display: "iframe",
    gallerySpan: 2,
    slug: "your-student-loan-receipt",
    title: "Your student loan receipt",
    categories: ["Dashboards & Scrollytelling"],
    description:
      "At 18, you took out a loan to go to uni. You didn't know much about how the loan worked, and now you're 30, and you still don't quite know what's up. Learn a little more through this interactive data storyboard!",
    projectTypes: [
      "Interactive Dashboard",
      "Web Scrollytelling",
      "Data Visualisation",
    ],
    designTools: ["Figma", "React.js"],
    graphicTools: ["RawGraphs 2.0"],
    analyticsTools: ["Excel", "Desk-based Research"],
    date: "2026-05-12",
    link: "https://your-student-loan-receipt.netlify.app/",
    linkLabel: "Link to website",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779132429/your-student-loan-receipt_i2vjym.mp4",
    thumbnailRatio: 1.06111111111,
    media: null,
    mediaType: "video",
    accentColor: "#EB8015",
    span: "normal",
  },

      {
    display: "media",
    slug: "political-polarisation-in-china-us",
    title: "Political Polarisation in China & US",
    categories: ["Data Graphics"],
    description:
      "Political polarisation overtime in China and the United States.",
    projectTypes: ["Data Visualisation"],
    designTools: ["Figma"],
    graphicTools: ["Flourish", "Excel", "Tableau"],
    analyticsTools: ["Excel"],
    date: "2025-09-05",
    link: "https://www.voronoiapp.com/politics/Political-Polarisation-in-China-and-USA-6473",
    linkLabel: "Link to Visual Capitalist Page →",
    sourceLabel: null,
    sourceLink:
      "https://v-dem.net/data/the-v-dem-dataset/country-year-v-dem-fullothers-v15/",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128956/political-polarisation-in-china-us_cq1cab.jpg",
    thumbnailRatio: 0.758659852,
    media: null,
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "normal",
  },
    {
    display: "media",
    slug: "the-banks-funding-carbon-bombs",
    title: "The Banks Funding Carbon Bombs",
    categories: ["Data Graphics"],
    description:
      "Carbon bombs 💣 are fossil fuel projects that will emit more than 1 gigatonne of CO2 in their remaining lifetime. As of today, there are 425 carbon bombs in operation or about to operate. If they all go through, they will emit DOUBLE the amount of our remaining carbon budget.",
    projectTypes: ["Data Visualisation"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["RawGraphs 2.0", "Flourish"],
    analyticsTools: ["Excel"],
    date: "2023-11-01",
    link: "https://www.voronoiapp.com/climate/The-Banks-Funding-Earths-Carbon-Bombs-1698",
    linkLabel: "Link to Visual Capitalist Page →",
    sourceLabel: null,
    sourceLink: "https://www.carbonbombs.org/",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128953/the-banks-funding-carbon-bombs_c2cd2y.jpg",
    thumbnailRatio: 0.642178269,
    media: null,
    mediaType: "image",
    accentColor: "#2D807C",
    span: "wide",
  },


    {
    display: "media",
    slug: "agricultural-workers-by-country",
    title: "Ranked: Number of Agricultural Workers by Country",
    categories: ["Data Graphics"],
    description:
      "The overwhelming majority - 52% - of people working in agriculture come from low-middle income countries in Asia and Sub-Saharan Africa. In stark comparison, only 3% of the world's agriculture workers come from high-income countries like the US and Europe.",
    projectTypes: ["Data Visualisation"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["Tableau", "Flourish"],
    analyticsTools: ["Excel"],
    date: "2023-07-01",
    link: "https://www.visualcapitalist.com/cp/agricultural-workers-by-country/",
    linkLabel: "Link to Visual Capitalist Page →",
    sourceLabel: "The World Bank Open Data",
    sourceLink: "https://data.worldbank.org/indicator/SL.AGR.EMPL.ZS",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128951/agricultural-workers-by-country_kghvws.jpg",
    thumbnailRatio: 0.458715596,
    media: null,
    mediaType: "image",
    accentColor: "#2D807C",
    span: "tall",
  },


    {
    display: "media",
    slug: "ghanas-state-of-cocoa",
    title: "Ghana's State of Cocoa",
    categories: ["Data Graphics", "Presentations"],
    description:
      "Ghana produces 19% of the world's cocoa beans. This animated video explores the main reasons why cocoa cultivation in Ghana is becoming more and more challenging.",
    projectTypes: ["Data Visualisation", "Animation"],
    designTools: ["Figma"],
    graphicTools: ["Excel"],
    analyticsTools: ["Excel"],
    date: "2024-06-28",
    link: null,
    linkLabel: null,
    sourceLabel: "Nat Geo Article",
    sourceLink:
      "https://www.nationalgeographic.com/science/article/ghana-gold-mining-cocoa-environment",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128957/ghanas-state-of-cocoa_mrzptv.mp4",
    thumbnailRatio: 0.5625,
    media: null,
    mediaType: "video",
    accentColor: "#EB8015",
    span: "normal",
  },
     {
    display: "media",
    slug: "is-cop-a-copout",
    title: "Is COP a COPout?",
    categories: ["Data Graphics"],
    description:
      "In recent years, these COPs have included an unprecedented number of private companies influencing policy. Amongst these notable players are unsurprisingly the fossil fuel lobbyists 🛢 ⛽ , who succeeded last year in weakening language from fossil fuel phase out ❌ to phase down ↘ .",
    projectTypes: ["Data Visualisation"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["RawGraphs 2.0"],
    analyticsTools: ["Excel"],
    date: "2023-12-01",
    link: null,
    linkLabel: null,
    sourceLabel: "kickbigpollutersout.org",
    sourceLink: "https://kickbigpollutersout.org/big-polluters-at-cop27",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128953/is-cop-a-copout_ng09jj.jpg",
    thumbnailRatio: 0.647836227,
    media: null,
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "normal",
  },



  {
    display: "media",
    slug: "artificial-snow-in-the-winter-games",
    title: "Artificial snow in the Winter Games",
    categories: ["Data Graphics"],
    description:
      "How much water was needed to create artificial snow for the Olympics and Paralympics?",
    projectTypes: ["Data Visualisation"],
    designTools: ["Figma"],
    graphicTools: ["none"],
    analyticsTools: ["Excel"],
    date: "2026-02-09",
    link: "https://www.voronoiapp.com/sports/Artificial-Snow-in-the-Winter-Olympics-7635",
    linkLabel: "Go to Visual Capitalist page",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128952/artificial-snow-in-the-winter-games_djovyc.jpg",
    thumbnailRatio: 0.758873929,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "normal",
  },


  {
    display: "iframe",
    slug: "beyond-skin-and-bones",
    title: "Beyond Skin and Bones",
    categories: ["Dashboards & Scrollytelling"],
    description:
      "A reinterpretation of an investigative report by TRAFFIC on a 25-year analysis of tiger seizures from 2000 to 2025.",
    projectTypes: [
      "Web Scrollytelling",
      "Data Visualisation",
      "Visual Journalism",
    ],
    designTools: ["Figma", "React.js"],
    graphicTools: ["RawGraphs 2.0", "Excel"],
    analyticsTools: ["Excel"],
    date: "2026-02-03",
    link: "https://train-jungle-79519186.figma.site/",
    linkLabel: "Go to page",
    sourceLabel: "TRAFFIC Full Report",
    sourceLink:
      "https://www.traffic.org/site/assets/files/29537/full_report_skin_and_bones_2025_v6_highres.pdf",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128954/beyond-skin-and-bones_bbmm2z.mp4",
    thumbnailRatio: 1.797752809,
    media: null,
    mediaType: "video",
    accentColor: "#2D807C",
    span: "wide",
  },


    {
    display: "media",
    slug: "culture-of-safety-can-make-or-break-nuclear-power-plants",
    title: "Culture of safety can make or break nuclear power plants",
    categories: ["Reports & Articles", "Client Projects"],
    description:
      "The March 11, 2011 Tohoku earthquake and tsunami had a devastating impact on Tokyo Electric Power Co.’s Fukushima nuclear power plants. However, we should also understand why Tohoku Electric Power Co.’s Onagawa Nuclear Power Station — which was closer to the epicenter of the 9.0-magnitude quake — had a drastically different fate.",
    projectTypes: ["Publication", "Research"],
    designTools: ["none"],
    graphicTools: ["none"],
    analyticsTools: ["Desk-based Research"],
    date: "2014-03-01",
    link: "https://www.japantimes.co.jp/opinion/2014/03/14/commentary/japan-commentary/culture-of-safety-can-make-or-break-nuclear-power-plants/",
    linkLabel: "Link to The Japan Times Article →",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779492572/Culture_of_safety_can_make_or_break_nuclear_power_plants___The_Japan_Times_jnxiiz.jpg",
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "normal",
  },
    {
    display: "iframe",
    slug: "risky-business",
    title: "Risky Business",
    categories: ["Dashboards & Scrollytelling"],
    description:
      "A data visual reinterpretation of Earthsight's investigative report on deforested timber in EU products.",
    projectTypes: [
      "Visual Journalism",
      "Web Scrollytelling",
      "Data Visualisation",
    ],
    designTools: ["Adobe Illustrator", "Figma", "React.js"],
    graphicTools: ["Excel", "RawGraphs 2.0"],
    analyticsTools: ["Desk-based Research"],
    date: "2026-01-22",
    link: "https://patent-mind-47847246.figma.site/",
    linkLabel: "Link to website",
    sourceLabel: "Webpage",
    sourceLink: "https://www.earthsight.org.uk/news/risky-business",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779130686/risky-business_yddhij.mp4",
    thumbnailRatio: 1.861111111,
    media: null,
    mediaType: "video",
    accentColor: "#2D807C",
    span: "wide",
  },




      {
    display: "media",
    slug: "pangolin-hunting-in-southeast-nigeria",
    title: "Pangolin Hunting in Southeast Nigeria",
    categories: ["Data Graphics"],
    description:
      "A visual representation highlighting the 4 main reasons why pangolin hunting in southeast Nigeria may be driven more by domestic demand than international demand of scales.",
    projectTypes: ["Data Visualisation", "Client Projects", "Infographic"],
    designTools: ["Figma"],
    graphicTools: ["Flourish", "RawGraphs 2.0"],
    analyticsTools: ["none"],
    date: "2025-04-29",
    link: null,
    linkLabel: null,
    sourceLabel: "Link to Nature",
    sourceLink: "https://www.nature.com/articles/s41559-025-02734-3",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128953/pangolin-hunting-in-southeast-nigeria_e0tppe.jpg",
    thumbnailRatio: 0.744874715,
    media: null,
    mediaType: "image",
    accentColor: "#2D807C",
    span: "tall",
  },
      {
    display: "media",
    slug: "civic-liberties-around-the-world",
    title: "Civic Liberties Around The World",
    categories: ["Data Graphics"],
    description:
      "Since 2018, 2.9 billion people - approximately 36% of the population 🌏 - have experienced a decrease ⤵ in their ability to safely protest, assemble and express their thoughts around the world. Less than 2% of the world's population lives in a county that has open civic space, where the state enables and safeguards the enjoyment of such rights ✊ . 80% of fully democratic countries do not have open civic spaces.",
    projectTypes: ["Data Visualisation"],
    designTools: ["Figma"],
    graphicTools: ["Excel", "Flourish"],
    analyticsTools: ["Excel"],
    date: "2024-08-02",
    link: "https://www.voronoiapp.com/politics/The-State-of-Civic-Space-Around-the-World-1973",
    linkLabel: "Link to Visual Capitalist Page →",
    sourceLabel: null,
    sourceLink: "https://monitor.civicus.org/",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128956/civic-liberties-around-the-world_ms4s5e.jpg",
    thumbnailRatio: 0.769671704,
    media: null,
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "tall",
  },
 {
    display: "iframe",
    slug: "inequality-in-the-coffee-value-chain",
    title: "Inequality in the Coffee Value Chain",
    categories: ["Reports & Articles", "Client Projects"],
    description:
      "Coffee producers from the Global South do not reap profits as high as importing countries from the Global North, contributing to economic inequality among producing countries. This report walks you through the history of the coffee industry and how consumers can make more informed purchases to create positive change. ",
    projectTypes: ["Data Visualisation", "Research", "Article"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["RawGraphs 2.0", "Flourish"],
    analyticsTools: ["Excel"],
    date: "2023-08-01",
    link: "https://infogr8.com/airi-ryu-inequality-coffee-value-chain/",
    linkLabel: "Link to infogr8 Article Page →",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#EB8015",
    span: "normal",
  },





  {
    display: "iframe",
    slug: "IDFC-report",
    title: "CPI - IDFC Green Finance Mapping Report 2025",
    categories: ["Reports & Articles", "Client Projects"],
    description:
      "Sample commissioned work with CPI to create data graphics for numerous public facing reports",
    projectTypes: ["Data Visualisation"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["RawGraphs 2.0"],
    analyticsTools: ["Excel"],
    date: "2025-02-10",
    link: "https://www.climatepolicyinitiative.org/wp-content/uploads/2025/11/IDFC-Green-Finance-Mapping-Report-2025-2.pdf",
    linkLabel: "Go to report",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "normal",
  },

  {
    display: "media",
    hidden: true,
    slug: "trumps-tariff-wars",
    title: "Trump's Tariff War",
    categories: ["Data Graphics"],
    description:
      "Visual timeline of the tit-for-tat between the United States and the World, with dedicated timelines for China, Canada and Mexico.",
    projectTypes: ["Visual Journalism", "Infographic"],
    designTools: ["Figma"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2025-04-17",
    link: "https://www.voronoiapp.com/geopolitics/Trumps-Tariff-War-as-of-April-17-4759",
    linkLabel: "Link to Visual Capitalist Page →",
    sourceLabel: null,
    sourceLink:
      "https://www.piie.com/blogs/realtime-economics/2025/trumps-trade-war-timeline-20-date-guide",
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#EB8015",
    span: "wide",
  },
  {
    display: "media",
    slug: "cbam-exposure-risk-iron-steel",
    title: "CBAM Exposure Risk: Iron & Steel",
    categories: ["Data Graphics"],
    description:
      "A map of the potential risk level by country of the implementation of the Carbon Border Adjustment Mechanism (CBAM), based on carbon intensity of iron and steel production.",
    projectTypes: ["Data Visualisation"],
    designTools: ["Figma"],
    graphicTools: ["Flourish", "RawGraphs 2.0"],
    analyticsTools: ["Excel", "Desk-based Research"],
    date: "2024-11-07",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink:
      "https://www.worldbank.org/en/data/interactive/2023/06/15/relative-cbam-exposure-index",
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128952/cbam-exposure-risk-iron-steel_xqvxy9.jpg",
    thumbnailRatio: 1.40625,
    media: null,
    mediaType: "image",
    accentColor: "#2D807C",
    span: "normal",
  },

  {
    display: "media",
    hidden: true,
    slug: "press-break-magazine",
    title: "Press Break Magazine Vol 0",
    categories: ["Illustrations"],
    description:
      "A magazine that guided guests on their coffee tasting journey throughout the world.",
    projectTypes: ["Illustration", "Magazine"],
    designTools: ["Procreate", "Figma"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2024-12-07",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#EB8015",
    span: "wide",
  },

  {
    display: "iframe",
    slug: "british-public-attitudes-towards-pornography",
    title: "British Public Attitudes Towards Pornography",
    categories: ["Reports & Articles", "Presentations", "Client Projects"],
    description:
      "In January 2024, CEASE commissioned More in Common to understand the British public's attitudes towards pornography and child exposure.",
    projectTypes: ["Data Visualisation", "Client Projects"],
    designTools: ["Adobe Illustrator", "Powerpoint"],
    graphicTools: ["Flourish", "RawGraphs 2.0"],
    analyticsTools: ["Excel"],
    date: "2024-03-18",
    link: "https://cease.org.uk/wp-content/uploads/2024/03/Public-Attitudes-toward-Pornography-CEASE-March-2024-3.pdf",
    linkLabel: "Link to CEASE UK",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128951/british-public-attitudes-towards-pornography_hkj6t1.jpg",
    thumbnailRatio: 1.777777778,
    media: null,
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "tall",
  },




  {
    display: "iframe",
    slug: "climate-justice-and-coffee",
    title: "Climate, Justice and Coffee",
    categories: ["Presentations", "Client Projects"],
    description:
      "What is the link between climate, justice and coffee? What is the story behind the everyday morning beverage we drink? In this presentation given to students at Climatebase, a climate career accelerator, I dive into how coffee can help teach us about some of the most pressing systemic issues we face today. The presentation will touch upon topics such as climate resilience, climate justice and colonial legacy in the coffee supply chain. It also encourages us to try to reimagine different futures for the coffee system given what we know now to propel us into action to help drive the future we want. By the end of the presentation, students will have hopefully gained more knowledge on the history of the coffee industry and how focusing on our agency to build the future we want is the way we avoid fatalism and transmute hopelessness to change.",
    projectTypes: [
      "Research",
      "Presentation",
      "Data Visualisation",
      "Illustration",
    ],
    designTools: ["Figma", "Procreate"],
    graphicTools: ["Flourish"],
    analyticsTools: ["Excel"],
    date: "2025-01-21",
    link: "https://www.youtube.com/embed/jDAtD4Znc40",
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128952/climate-justice-and-coffee_thli93.mp4",
    thumbnailRatio: 2,
    media: null,
    mediaType: "video",
    accentColor: "#EB8015",
    span: "tall",
  },
  {
    display: "media",
    slug: "reinventing-post-disaster-shelter-provision",
    title: "iDMC - Reinventing Post-Disaster Shelter Provision",
    categories: ["Reports & Articles", "Client Projects"],
    description:
      "A background report published as  part of Internal Displacement Monitoring Centre (IDMC)'s GRID 2020 report on global internal displacement. The report is developed off the back of my dissertation about the lesser known struggles of delivering volunteer-driven shelter to displaced people. Although the report discusses current gaps in the shelter delivery system, it also highlights the potential that individuals have in making a real difference. ",
    projectTypes: ["Publication", "Research"],
    designTools: ["none"],
    graphicTools: ["none"],
    analyticsTools: ["Desk-based Research"],
    date: "2020-04-01",
    link: "https://www.internal-displacement.org/global-report/grid2020/downloads/background_papers/2020-IDMC-GRID-background-post-disaster-shelter.pdf",
    linkLabel: "Link to iDMC Background Report →",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779493063/reinventing-post-disaster-shelter-provision_vweaq3.jpg",
    mediaType: "image",
    accentColor: "#2D807C",
    span: "normal",
  },
  {
    display: "media",
    slug: "reinventing-post-natural-disaster-prevention",
    title:
      "University of Cambridge - Reinventing Post-Natural Disaster Shelter Provision",
    categories: ["Data Graphics"],
    description:
      "A visual representation of my dissertation at the University of Cambridge on evaluating the potential of existing accommodation as alternative shelter in urban disaster response.",
    projectTypes: ["Infographic"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["Excel"],
    analyticsTools: ["Excel"],
    date: "2019-07-01",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128953/reinventing-post-natural-disaster-prevention_lxgkwq.jpg",
    thumbnailRatio: 0.706375839,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/image/upload/v1779128953/reinventing-post-natural-disaster-prevention_lxgkwq.jpg",
    mediaType: "image",
    accentColor: "#2D807C",
    span: "wide",
  },
  {
    display: "link",
    slug: "system-failures-in-japans-evacuation-centres",
    title: "System failures in Japan's evacuation centres",
    categories: ["Reports & Articles"],
    description:
      "In January 2020, I went to an evacuation centre set up in Iwaki, Japan for people whose homes were damaged or destroyed by Typhoon Hagibis in October 2019. When I visited, 3 months had past since the typhoon hit, yet 68 people still lived inside these school gyms. With the help of Peace Boat, a Japan-based international NGO, I was able to see the current reality inside these evacuation centres. What I found was surprising to say the least.",
    projectTypes: ["Research", "Article"],
    designTools: ["none"],
    graphicTools: ["none"],
    analyticsTools: ["Field Study"],
    date: "2020-01-01",
    link: "https://www.linkedin.com/pulse/system-failures-still-exist-evacuation-centres-3-months-ryu",
    linkLabel: "Link to the LinkedIn Article →",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "normal",
  },
  {
    display: "iframe",
    slug: "who-is-displaced-by-disasters",
    title:
      "Who is displaced by disasters, what do they experience and how can we make a difference?",
    categories: ["Presentations", "Client Projects"],
    description:
      "What do we imagine when we hear the term ‘internal displacement’? Do we think of it as something that will never happen to us? As something that is far from our daily lives? Do we consider that perhaps anyone – whether young or old, rich or poor – can become displaced? Focusing on disaster displacement, this video sheds light on what it means to be internally displaced in the modern age of climate change and rapid urbanisation. The video is based on stories heard while visiting an evacuation centre in Japan, opened after Typhoon Hagibis in October 2019. I reflect on the difficulties faced by those who have lost their homes. This includes dependency on governmental support and aggravated health and wellbeing. I also attempt to deconstruct what it means to provide support to displaced people. Are current disaster management plans effective? If not, why and what can we do to improve this? Moreover, who should be responsible for providing support? Should we depend solely on government and international organisations for aid, or can individuals also make a difference to support those who are displaced? With the continuation of anthropogenic climate change, we will see a future with more and stronger disasters. This means more homes destroyed, more evacuation orders, and more people becoming internally displaced and in need of new homes and communities. Knowing this, it has never been more critical to reimagine who will be displaced and how we can help.",
    projectTypes: ["Research", "Presentation"],
    designTools: ["Powerpoint"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-05-01",
    link: "https://www.routedmagazine.com/omc2020-3-displaced-disasters",
    linkLabel: "Link to Oxford Migration Conference 2020 Site →",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128953/who-is-displaced-by-disasters_k3qu68.mp4",
    thumbnailRatio: 1.6,
    media: null,
    mediaType: "video",
    accentColor: "#2D807C",
    span: "tall",
  },

  {
    hidden: true,
    slug: "oiso-yuru-kyara-entry",
    title: "Oiso Yuru-kyara Entry",
    categories: ["Illustrations"],
    description:
      "An entry for Oiso town's mascot design call. Meet Rakko-ron — an otter life guard from Oiso Long Beach who loves to swim and keep friends safe.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2019-02-01",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    hidden: true,
    slug: "classmates-caricatures",
    title: "Classmate's Caricatures",
    categories: ["Illustrations"],
    description:
      "A thank you gift to my master's class — 27 caricatures capturing the personality and energy of each classmate, drawn by hand and finished in Adobe Illustrator.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2019-08-30",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "wide",
  },
  {
    hidden: true,
    slug: "tokyo-2020-mascot-entry",
    title: "Tokyo 2020 Mascot Entry",
    categories: ["Illustrations"],
    description:
      "My entry for the Tokyo 2020 Olympics and Paralympics open call for mascot designs — shortlisted but didn't win.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2017-08-01",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    hidden: true,
    slug: "the-last-dino-on-earth",
    title: "The Last Dino on Earth",
    categories: ["Illustrations"],
    description:
      "My first ever illustration project — online stickers for LINE featuring Ryu-chan the dino, inspired by people telling me I look like a dinosaur.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Adobe Illustrator"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2016-12-01",
    link: "https://store.line.me/stickershop/product/1361900/en",
    linkLabel: "Link to LINE Store →",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "tall",
  },
  {
    hidden: true,
    slug: "solidarity-with-blm",
    title: "Solidarity with BLM",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "A drawing posted on Instagram to show solidarity with the BLM movement. Social justice = Climate justice.",
    projectTypes: ["Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-06-01",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#A65E5D",
    span: "normal",
  },
  {
    hidden: true,
    slug: "the-little-water-movers",
    title: "The Little Water Movers",
    categories: ["Illustrations"],
    description:
      "A piece for Water Aid and #ArtofChange to inspire world leaders to increase investment in water and hygiene projects in least developed nations.",
    projectTypes: ["Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-07-01",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#2D807C",
    span: "normal",
  },
  // ── Dear Sustie series ────────────────────────────────────────────────────
  {
    display: "media",
    slug: "dear-sustie-how-do-you-shop-for-clothes",
    title: "Dear Sustie: How do you shop for clothes?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "The fashion industry is responsible for 20% of the world's wastewater and 10% of global carbon emissions. What can we do about it?",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-03-13",
    link: "https://www.instagram.com/p/B9rhIR6JhNo",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-how-do-you-shop-for-clothes_imxusm.mp4",
    thumbnailRatio: 1,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-how-do-you-shop-for-clothes_imxusm.mp4",
    mediaType: "video",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    slug: "dear-sustie-what-type-of-milk-do-you-drink",
    title: "Dear Sustie: What type of milk do you drink?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "One glass of dairy milk produces three times more greenhouse gas than alternative milks — but which plant-based option is actually the most sustainable?",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-03-25",
    link: "https://www.instagram.com/p/B-LPeD7JdtQ",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-what-type-of-milk-do-you-drink_wg3gv7.mp4",
    thumbnailRatio: 1,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-what-type-of-milk-do-you-drink_wg3gv7.mp4",
    mediaType: "video",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    slug: "dear-sustie-what-is-your-diet-like",
    title: "Dear Sustie: What is your diet like?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "Livestock production accounts for 16.5% of the entire world's carbon emissions. Even reducing your meat consumption is a huge step.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-05-30",
    link: "https://www.instagram.com/p/CA0sJQ3p24R",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128955/dear-sustie-what-is-your-diet-like_jvogzq.mp4",
    thumbnailRatio: 1,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128955/dear-sustie-what-is-your-diet-like_jvogzq.mp4",
    mediaType: "video",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    hidden: true,
    slug: "dear-sustie-how-do-you-drink-your-coffee",
    title: "Dear Sustie: How do you drink your coffee?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "Only 1 in 400 cups are being recycled in the UK. What's the most eco-friendly way to get your daily coffee fix?",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-02-25",
    link: null,
    linkLabel: null,
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: 1,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    slug: "dear-sustie-how-do-you-heat-your-home",
    title: "Dear Sustie: How do you heat your home?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "In the UK, heating buildings is responsible for 69% of built environment emissions. The good news — there are lots of things you can do.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-04-04",
    link: "https://www.instagram.com/p/B-j5wAcpoYo",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128956/dear-sustie-how-do-you-heat-your-home_gh4oli.mp4",
    thumbnailRatio: 1,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128956/dear-sustie-how-do-you-heat-your-home_gh4oli.mp4",
    mediaType: "video",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    slug: "dear-sustie-how-do-you-grocery-shop",
    title: "Dear Sustie: How do you grocery shop?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "1.1 million seabirds and animals die every year because of single-use plastic. But cotton bags need to be used 7,000 times to have less impact than plastic.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-02-28",
    link: "https://www.instagram.com/p/B9HCpSkJeX4",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-how-do-you-grocery-shop_vzifvd.mp4",
    thumbnailRatio: 1,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-how-do-you-grocery-shop_vzifvd.mp4",
    mediaType: "video",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    hidden: true,
    slug: "dear-sustie-how-do-you-travel",
    title: "Dear Sustie: How do you travel?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "Short haul flights emit over 42 times more CO₂ per km than the Eurostar. So why is flying still cheaper?",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-02-28",
    link: "https://www.instagram.com/p/B9HDVnfpxZx",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail: null,
    thumbnailRatio: null,
    media: null,
    mediaType: "image",
    accentColor: "#E1C1C0",
    span: "normal",
  },
  {
    display: "media",
    slug: "dear-sustie-how-do-you-shower",
    title: "Dear Sustie: How do you shower?",
    categories: ["Illustrations", "Dear Sustie"],
    description:
      "In the UK, 89% of carbon emissions due to water use comes from heating water in homes. Simple changes can make a big difference.",
    projectTypes: ["Character Design", "Illustration"],
    designTools: ["Procreate"],
    graphicTools: ["none"],
    analyticsTools: ["none"],
    date: "2020-03-05",
    link: "https://www.instagram.com/p/B9WzLUrpWZh",
    linkLabel: "Go to post",
    sourceLabel: null,
    sourceLink: null,
    thumbnail:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-how-do-you-shower_cwuiwz.mp4",
    thumbnailRatio: 1,
    media:
      "https://res.cloudinary.com/dnx3tgmxg/video/upload/v1779128951/dear-sustie-how-do-you-shower_cwuiwz.mp4",
    mediaType: "video",
    accentColor: "#E1C1C0",
    span: "normal",
  },
];

// ─────────────────────────────────────────────────────────────────────────────
// TOOLS STRIPS
// ─────────────────────────────────────────────────────────────────────────────

export const toolsRow1 = [
  { name: "Figma" },
  { name: "Adobe Illustrator" },
  { name: "Procreate" },
  { name: "React.js" },
  { name: "Powerpoint"},
];

export const toolsRow2 = [
    { name: "Excel" },
  { name: "Flourish" },
  { name: "RawGraphs 2.0" },
  { name: "Tableau" },
  { name: "Power BI" },
  { name: "Python" },
];

// ─────────────────────────────────────────────────────────────────────────────
// PROCESS STEPS
// ─────────────────────────────────────────────────────────────────────────────

export const processSteps = [
  {
    number: "01",
    title: "Choose Topic",
    imageSrc: null,
    body: "Find the potential story via market research, skimming news, or client request",
  },
  {
    number: "02",
    title: "Gather Data",
    imageSrc: null,
    body: "Collect as much information via open-sourced data or client-provided datasets.",
  },
  {
    number: "03",
    title: "Build Story",
    imageSrc: null,
    body: "Uncover the message hidden in the data via statistics, modelling and analysis.",
  },
  {
    number: "04",
    title: "Visualise",
    imageSrc: null,
    body: "Finding the best graphic(s) that tell the most compelling story. Static or interactive.",
  },
  {
    number: "05",
    title: "Customise Design",
    imageSrc: null,
    body: "Beautifying the final product to make it visually captivating.",
  },
];

export const visibleItems = portfolioItems.filter((i) => !i.hidden);
